import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      navigate(u.is_admin ? "/admin" : from, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid grid-cols-1 lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src="/images/hero-house.jpg" className="absolute inset-0 w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-deep-forest/40" />
        <div className="absolute bottom-12 left-12 right-12 text-warm-sand">
          <div className="label-overline text-warm-sand/80">— Welcome back</div>
          <h2 className="font-serif text-5xl mt-3 leading-tight italic font-light">Pick up where you left off.</h2>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16">
        <form onSubmit={handleSubmit} className="w-full max-w-sm" data-testid="login-form">
          <div className="label-overline mb-4">— Log in</div>
          <h1 className="font-serif text-4xl text-deep-forest tracking-tight">Good to see you again.</h1>

          <div className="mt-8 space-y-6">
            <div>
              <label className="text-xs uppercase tracking-widest text-deep-forest/60">Email</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="field-line" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-widest text-deep-forest/60">Password</label>
              <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="field-line" />
            </div>
          </div>

          <button data-testid="login-submit-btn" type="submit" disabled={loading} className="btn-primary w-full justify-center mt-8">
            {loading ? "Signing in…" : "Sign in"}
          </button>

          <div className="my-6 flex items-center gap-4 text-xs uppercase tracking-widest text-deep-forest/40">
            <div className="flex-1 h-px bg-deep-forest/10" /> or <div className="flex-1 h-px bg-deep-forest/10" />
          </div>

          <button type="button" data-testid="login-google-btn" onClick={handleGoogle} className="btn-secondary w-full justify-center">
            <svg className="w-4 h-4" viewBox="0 0 24 24"><path fill="currentColor" d="M21.35 11.1H12v3.2h5.35c-.23 1.4-1.74 4.1-5.35 4.1-3.22 0-5.85-2.66-5.85-5.95s2.63-5.95 5.85-5.95c1.83 0 3.06.78 3.77 1.45l2.57-2.48C16.55 3.93 14.5 3 12 3 6.97 3 2.88 7.05 2.88 12s4.09 9 9.12 9c5.27 0 8.75-3.7 8.75-8.91 0-.6-.07-1.06-.15-1.49z"/></svg>
            Continue with Google
          </button>

          <p className="mt-8 text-sm text-deep-forest/60">
            New here? <Link to="/register" data-testid="login-go-register" className="text-terracotta hover:underline">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
